"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadius = exports.fontSize = exports.spacing = exports.zIndexes = exports.deviceSizes = void 0;
var deviceSizes = {
  desktopLg: 1200,
  // TBD
  desktop: 1080,
  tablet: 600,
  // TBD
  phone: 768,
  xs: 350
};
exports.deviceSizes = deviceSizes;
var zIndexes = {
  child: 1,
  select: 2,
  fav: 3,
  pulldown: 4,
  map: 5,
  main: 6,
  button: 7,
  lightbox: 8,
  baloon: 9,
  nav: 10,
  header: 11,
  topmost: 12
};
exports.zIndexes = zIndexes;
var spacing = {
  tiny: 3,
  tiny_2: 4,
  small: 6,
  small_2: 8,
  small_3: 12,
  medium: 16,
  medium__15: 20,
  medium_2: 24,
  medium_3: 32,
  large: 40,
  large_2: 48,
  huge: 56,
  huge__25: 64,
  huge__26: 72,
  huge_2: 80
};
exports.spacing = spacing;
var fontSize = {
  tiny: 10,
  small: 11,
  small_2: 12,
  small__25: 13,
  small_3: 14,
  medium: 16,
  medium_2: 18,
  large: 20,
  large_2: 24,
  large_3: 28,
  huge: 32,
  huge_2: 36,
  huge_3: 40
};
exports.fontSize = fontSize;
var borderRadius = 3;
exports.borderRadius = borderRadius;